package songwritersnotebook.app.utils

object FractionalIndexer {
    private const val BASE = "abcdefghijklmnopqrstuvwxyz"
    
    fun generateInitial(): String = "m"

    fun generateBetween(prev: String?, next: String?): String {
        val p = prev ?: ""
        val n = next ?: "z"
        
        var i = 0
        val result = StringBuilder()
        
        while (true) {
            val prevChar = p.getOrNull(i) ?: ' '
            val nextChar = n.getOrNull(i) ?: (if (i < p.length) ' ' else 'z')
            
            if (prevChar == nextChar) {
                result.append(prevChar)
                i++
                continue
            }
            
            val prevVal = if (prevChar == ' ') -1 else BASE.indexOf(prevChar)
            val nextVal = if (nextChar == ' ') BASE.length else BASE.indexOf(nextChar)
            
            if (nextVal - prevVal > 1) {
                val midVal = (prevVal + nextVal) / 2
                result.append(BASE[midVal])
                break
            } else {
                result.append(prevChar)
                i++
            }
        }
        return result.toString()
    }
}
